<template>
	<div class="watch-biometric-alert-view-history">
		<!-- <h1>{{ $t('headers.general.readings') }}</h1> -->
		<spinner v-if="readings.loading"/>
		<div v-if="readings.data.length" class="idi-table readings">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell">{{ $t('labels.general.hour') }}</div>
				<div class="idi-cell">{{ $t('labels.general.value') }}</div>
			</div>
			<div class="idi-row" v-for="reading in readings.data" :key="reading.id">
				<div class="idi-cell">{{ date(reading.date) }}</div>
				<div class="idi-cell">{{ reading.date | formatTime(vue) }}</div>
				<div class="idi-cell">{{ value(reading) }}&nbsp;<span v-html="units"></span></div>
			</div>
		</div>
		<!--
		<h1>{{ $t('headers.general.notifications') }}</h1>
		<spinner v-if="warnings.loading"/>
		<div v-if="!warnings.loading && warnings.data.length" class="idi-table warnings">
			<div class="idi-header">
				<div class="idi-cell">{{ $t('labels.general.date') }}</div>
				<div class="idi-cell">{{ $t('labels.general.hour') }}</div>
				<div class="idi-cell">{{ $t('labels.general.person') }}</div>
				<div class="idi-cell">{{ $t('labels.general.status') }}</div>
			</div>
			<div class="idi-row" v-for="warning in warnings.data" :key="warning.id">
				<div class="idi-cell">{{ date(warning.date) }}</div>
				<div class="idi-cell">{{ warning.date | formatTime(vue) }}</div>
				<div class="idi-cell">{{ warning.user.fullname }}</div>
				<div class="idi-cell">{{ status(warning.warning.reading_time) }}</div>
			</div>
		</div>
		<div v-if="!warnings.loading && !warnings.data.length">{{ $t('labels.general.no_notifications') }}</div>
		-->
	</div>
</template>

<script>
import Readings from '@/utils/readings'
export default {
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'alert_id'
	],
	data () {
		return {
			vue: this,
			componentName: 'watch biometric alert history view history',
			readings: {
				loading: false,
				error: null,
				data: []
			},
			warnings: {
				loading: false,
				error: null,
				data: []
			}
		}
	},
	computed: {
		units () {
			return Readings.readingTypes.get(parseInt(this.type_id)).unitHtml
		}
	},
	methods: {
		date (date) {
			return this.$moment(date).format('DD MMM YYYY')
		},
		value (reading) {
			switch (parseInt(this.type_id)) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `${reading.values.systolic} ${reading.values.diastolic}`
				case Readings.TYPE_FALLS:
					return this.$t('readings.falls.fall_detected')
				case Readings.TYPE_GEOFENCING:
					return `${reading.values.latitude} ${reading.values.longitude}`
				default:
					return reading.values.value
			}
		},
		status (date) {
			return date ? this.$t('labels.general.responded') : this.$t('labels.general.not_responded')
		},
		getReadings () {
			this.readings.loading = true
			this.$api.alerts.getReadings(this, this.user_uid, this.watch_id, this.type_id, this.alert_id)
				.then(response => {
					this.$log.info(this.componentName, 'alerts.getReadings OK', response)()
					this.readings.data = response.body
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.getReadings ERROR', error)()
					this.readings.error = error
				}).finally(() => {
					this.readings.loading = false
				})
		},
		getWarnings () {
			this.warnings.loading = true
			this.$api.alerts.getWarnings(this, this.user_uid, this.watch_id, this.type_id, this.alert_id)
				.then(response => {
					this.$log.info(this.componentName, 'alerts.getWarnings OK', response)()
					this.warnings.data = response.body
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.getWarnings ERROR', error)()
					this.warnings.error = error
				}).finally(() => {
					this.warnings.loading = false
				})
		}
	},
	mounted () {
		this.getReadings()
		this.getWarnings()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alertsV2/ReadingsAlertViewHistory.vue